<div
  *ngIf="!!errorMessage"
  class="white-message-box"
  [innerHTML]="errorMessage"
></div>